/*
  if Fullstory is not enabled, replace the FS module with empty functions
*/
const fullstory = window.FS != null ? window.FS : { identify: () => {} };

export const setUserProperties = (userId, properties) => {
  fullstory.identify(userId, {...properties});
};

/**
 * Return the URL of the current FullStory session, or null if FullStory
 * is not loaded / no session is active.
 *
 * Passing `now = true` deep-links to the moment the URL was requested
 * (e.g. the moment an error occurred), which is what we want for Sentry.
 */
export const getCurrentSessionURL = (now = true) => {
  if (window.FS == null) return null;

  try {
    if (typeof window.FS.getCurrentSessionURL === 'function') {
      return window.FS.getCurrentSessionURL(now) || null;
    }
    if (typeof window.FS === 'function') {
      return (
        window.FS('getSession', { format: 'url.now' }) ||
        window.FS('getSession', { format: 'url' }) ||
        null
      );
    }
  } catch (error) {
    return null;
  }

  return null;
};
